export default {
	subacute: 1,
	acute: 2,
	chronic: 4,
	traumatic: 8,
	non_traumatic: 16,
} as const;
